import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "item pt-xs-4 pb-xs-4" }
const _hoisted_2 = { class: "type-flag" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = { class: "supporting-details mt-xs-2" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_9 = ["href", "aria-label"]
const _hoisted_10 = { class: "newsletter-title pl-xs-1" }


const __default__ = {
  name: 'SearchItemCard',
}
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  uri: {
    type: String,
    default: '',
    required: false,
  },
  entry_type_label: {
    type: String,
    default: 'No Type',
    required: true,
  },
  parent_label: {
    type: String,
    default: '',
    required: false,
  },
  parent_link: {
    type: String,
    default: '',
    required: false,
  },
  postdate: {
    type: [Date, String],
    default: '',
    required: false,
  },
},
  setup(__props) {

const props = __props



// Util function
const stringWithoutSpace = (value: string): string => {
  // Take any string: remove special characters & spaces, replace with single underscore, make all characters lowercase
  return value.replace(/[^A-Z0-9]+/ig, '_').toLowerCase()
}

// Computed property to format the postdate
const formattedPostDate = computed(() => {
  if (!props.postdate) return ''
  
  const date = new Date(props.postdate)
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date)
})

// Computed property for typeColor to avoid recalculating it each time
const typeColor = computed(() => {
  switch (props.entry_type_label) {
    case 'article':
      return 'blue'
    case 'newsletter':
      return 'orange'
    case 'blog_post':
      return 'green'
    case 'book':
      return 'purple'
    default:
      return 'blue'
  }
})

// Method to process the title by replacing underscores with spaces
const removeUnderscores = (textValue: string): string => {
  return textValue.replace(/_/g, ' ')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(['pt-xs-1 pb-xs-1 pr-xs-2 pl-xs-2', _unref(typeColor)]),
        "aria-live": "polite"
      }, _toDisplayString(removeUnderscores(__props.entry_type_label)), 3)
    ]),
    _createElementVNode("h2", {
      id: stringWithoutSpace(__props.name),
      class: "title mt-xs-2"
    }, [
      _createElementVNode("a", {
        href: __props.uri,
        "aria-label": `Click here to read more about ${__props.name}`,
        tabindex: "0"
      }, _toDisplayString(__props.name), 9, _hoisted_4)
    ], 8, _hoisted_3),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("small", {
        class: "postDate",
        "aria-label": `${__props.entry_type_label} Published Date: ${_unref(formattedPostDate)}`
      }, _toDisplayString(_unref(formattedPostDate)), 9, _hoisted_6),
      (__props.parent_link && __props.parent_label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("a", {
              href: __props.parent_link,
              "aria-label": `Click here to view ${__props.parent_label} newsletter`
            }, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: ['far', 'newspaper'],
                class: "newspaper-icon-size",
                "aria-hidden": "true"
              }),
              _createElementVNode("small", null, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(__props.parent_label), 1)
              ])
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})